import {RequestInfo} from "@khan/shared-core";

/**
 * Utility function that attempts to detect iPad and iPhone devices.
 * We do this because scrolling in iOS is broken for Safari versions prior to
 * iOS 17, and we need to implement a combination of JS and CSS to make the
 * Khanmigo chat experience more in line with desktop.
 *
 * NOTE: This is NOT SSR safe. It should only be used in the browser, which currently
 * is not a problem since Khanmigo is only rendered for logged-in users.
 *
 * Based on solutions discussed here:
 * https://stackoverflow.com/questions/57776001/how-to-detect-ipad-pro-as-ipad-using-javascript
 * */
export const maybeIOS = () =>
    RequestInfo.isIOS ||
    (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 2);
